import { useContent } from '@/stores/RootStore';
import { observer } from 'mobx-react-lite';
import s from './Timeline.module.scss';

// 주요연혁 — evstech 타임라인 이미지를 EVS 컨셉(좌측 레일 · 시안 노드 · 네이비 연도)으로 벡터 재해석(2026-08-02).
//   좌측 세로 라인 + 연도 배지, 각 이벤트는 월 칩 + 텍스트. 최신순.
const Timeline = observer(() => {
  const { history } = useContent();
  return (
    <div className={s.timeline}>
      <span className={s.rail} aria-hidden />
      {history.map((group) => (
        <div key={group.year} className={s.group}>
          <div className={s.year}>{group.year}</div>
          <ul className={s.events}>
            {group.events.map((e, i) => (
              <li key={i} className={s.event}>
                <span className={s.dot} aria-hidden />
                <span className={s.month}>{e.month}</span>
                <span className={s.text}>{e.text}</span>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
});

export default Timeline;
